module.exports = __webpack_public_path__ + "img/preview.d54610c8.webp";